export default __webpack_public_path__ + "static/media/number2.fc563c2e.svg";